import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Cookie } from 'ng2-cookies';

import * as _ from 'lodash';

import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable, throwError, Subject } from 'rxjs';

//import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { take, filter } from 'rxjs/operators';

import { environment } from '../environments/environment';

import { NgxSpinnerService } from 'ngx-spinner';
import { of } from 'rxjs';
import { catchError, retry, tap } from 'rxjs/operators';

export class Foo {
  constructor(
    public result: object) { }
}

@Injectable({
  providedIn: "root",
})
export class AppService {
  private regenerateCaptchaSubject = new Subject<void>();
  public regenerateCaptcha$ = this.regenerateCaptchaSubject.asObservable();

  constructor(
    private _router: Router, private _http: HttpClient, private spinnerService: NgxSpinnerService) { }

  obtainAccessToken(loginData) {
    let params = new URLSearchParams();
    params.append('username', loginData.username);
    params.append('password', loginData.password);
    params.append('grant_type', 'password');
    params.append('client_id', 'oauth_client_id');
    //params.append('client_id','oauth_client_id');


    let headers = new HttpHeaders({ 'Content-type': 'application/x-www-form-urlencoded; charset=utf-8', 'Authorization': 'Basic ' + btoa("oauth_client_id:secret") });
    let options = { headers: headers, responseType: 'json' };

    /*
    let options: {
      headers?: HttpHeaders | {[header: string]: string | string[]},
      observe?: 'body' | 'events' | 'response',
      params?: HttpParams|{[param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>},
      reportProgress?: boolean,
      responseType?: 'arraybuffer'|'blob'|'json'|'text',
      withCredentials?: boolean,
  }
*/
    console.log(params.toString());
    this._http.post(environment.authServer + '/auth/api/oauth/token', params.toString(), { headers, responseType: 'json' })
      // .map(res => res.json())
      .subscribe(
        data => this.saveToken(data),
        err => {
          alert('Invalid Sms code');
          this.spinnerService.hide();
          this._router.navigate(['/prelogin', loginData.username]);
        });
  }

  confirm(transaction_id) {
    console.log("confirm transaction: " + environment.apiServer + `/api/client/confirm/intent/${transaction_id}`);
    let headers = new HttpHeaders({ 'Content-type': 'application/json; charset=utf-8' });

    this._http.post(environment.apiServer + `/api/client/confirm/intent/${transaction_id}`, null, { headers, responseType: 'json', observe: 'response' })
      // .map(res => res.json())
      .subscribe({
        next: data => {
          console.log("confirm transaction data: " + data);
          // torniamo al wallet
          this._router.navigate(['/wallet']);
        },
        error: error => {
          alert('Invalid confirm ' + JSON.stringify(error));
          this.spinnerService.hide();
          this._router.navigate(['/wallet']);
        }
      });
  }

  cancel(transaction_id) {
    console.log("cancel transaction");
    let headers = new HttpHeaders({ 'Content-type': 'application/json; charset=utf-8' });

    this._http.post(environment.apiServer + `/api/client/cancel/intent/${transaction_id}`, null, { headers, responseType: 'json', observe: 'response' })
      // .map(res => res.json())
      .subscribe({
        next: data => {
          console.log("cancel transaction data: " + data);
          // torniamo al wallet
          this._router.navigate(['/wallet']);
        },
        error: error => {
          alert('Invalid confirm ' + JSON.stringify(error));
          this.spinnerService.hide();
          this._router.navigate(['/wallet']);
        }
      });
    /*
    .subscribe(
      data => {
        console.log("cancel transaction data: "+ data);
        this._router.navigate(['/wallet']);
      },
      err => {
        alert('Invalid cancel ' + JSON.stringify(err.error));
        this.spinnerService.hide();
        this._router.navigate(['/wallet']);
        // this._router.navigate(['/prelogin', loginData.username]);
      });
      */
  }

  preLogin(loginData) {

    let headers = new HttpHeaders({ 'Content-type': 'application/json; charset=utf-8' });

    this._http.post(environment.authServer + '/auth/public/app/prelogin', JSON.stringify(loginData), { headers, responseType: 'json', observe: 'response' })
      // .map(res => res.json())
      .subscribe(
        data => {
          this.spinnerService.hide();
          console.log(data);
          if (data.status == 200) {
            this._router.navigate(['/login', loginData.phone]);
          } else {
            alert("INVALID OR NOT EXISTING PIN");
            this._router.navigate(['/prelogin', loginData.phone]);
          }
        },
        err => {
          console.log(err);
          alert('Invalid Credentials'); this.spinnerService.hide();
        });
  }

  preChangePin(loginData) {

    let headers = new HttpHeaders({ 'Content-type': 'application/json; charset=utf-8' });

    this._http.post(environment.authServer + '/auth/public/app/prechangepin', JSON.stringify(loginData), { headers, responseType: 'json', observe: 'response' })
      // .map(res => res.json())
      .subscribe(
        data => {
          this.spinnerService.hide();
          console.log(data);
          if (data.status == 200) {
            this._router.navigate([`/changepin/${loginData.phone}/${loginData.pin}`]);
          } else {
            alert("INVALID OR NOT EXISTING PIN");
            this._router.navigate(['/prechangepin', loginData.phone]);
          }
        },
        err => {
          console.log(err);
          alert('Invalid Credentials'); this.spinnerService.hide();
        });
  }

  register(registerData) {
    let params = new URLSearchParams();


    let headers = new HttpHeaders({ 'Content-type': 'application/json; charset=utf-8' });

    this._http.post(environment.authServer + '/auth/public/app/signup', JSON.stringify(registerData), { headers, responseType: 'json' })
      .subscribe(data => {
        console.log(data);
        this.spinnerService.hide();
        this._router.navigate([`/prelogin/${registerData.username}/${registerData.password}`]);
        // this._router.navigate(['/login', registerData.username]);
        // this.preLogin({ phone: registerData.username, pin: registerData.password});
        // this.obtainAccessToken(registerData);
      },
        err => {
          console.log(err);
          this.spinnerService.hide()
          if (err.status == 409) {
            alert('User exists');
            this._router.navigate(['/prelogin', registerData.username]);
          } else {
            alert('Invalid SignUp');
          }

        });
    /*
    console.log(params.toString());
     this._http.post('http://localhost:8091/public/app/signUp', params.toString(), options)
    .map(res => res.json())
    .subscribe(
      data => { 
        console.log(data);
        // this.saveToken(data) 
      },
      err => {alert('Invalid SignUp'); this.spinnerService.hide()});
    ); 
    */
  }

  changepin(registerData) {
    let params = new URLSearchParams();


    let headers = new HttpHeaders({ 'Content-type': 'application/json; charset=utf-8' });

    this._http.post(environment.authServer + '/auth/public/app/changepin', JSON.stringify(registerData), { headers, responseType: 'json' })
      .subscribe(data => {
        console.log(data);
        // this._router.navigate(['/login', registerData.phone]);
        // this.preLogin({ phone: registerData.username, pin: registerData.password});
        // this.obtainAccessToken({username: registerData.phone, password: registerData.code});
      },
        err => {
          console.log(err);
          this.spinnerService.hide()
          if (err.status == 200) {
            alert('Pin changed!');
            // this._router.navigate(['/prelogin', registerData.username]);
            this.obtainAccessToken({ username: registerData.phone, password: registerData.code });
          } else {
            alert('Error changing the pin');
          }

        });
    /*
    console.log(params.toString());
     this._http.post('http://localhost:8091/public/app/signUp', params.toString(), options)
    .map(res => res.json())
    .subscribe(
      data => { 
        console.log(data);
        // this.saveToken(data) 
      },
      err => {alert('Invalid SignUp'); this.spinnerService.hide()});
    ); 
    */
  }

  ccpay(registerData) {
    let headers = new HttpHeaders({ 'Content-type': 'application/json; charset=utf-8' });

    this._http.post(environment.apiServer + '/api/v1/payment-methods/payments', JSON.stringify(registerData), { headers, responseType: 'json' , observe: 'response'})
      // .map(res => res.json())
      .subscribe({
        next: data => {
          this.spinnerService.hide();
          console.log("confirm transaction data: " + data);
          location.href = data.body["payment_url"];

          // torniamo al wallet
          // this._router.navigate(['/wallet']);
        },
        error: error => {
          alert('Invalid confirm ' + JSON.stringify(error));
          this.spinnerService.hide();
          //this._router.navigate(['/wallet']);
        }
      });
  }

  ccpay1(registerData) {
    let params = new URLSearchParams();


    let headers = new HttpHeaders({ 'Content-type': 'application/json; charset=utf-8' });

    this._http.post(environment.apiServer + '/api/v1/payment-methods/payments', JSON.stringify(registerData), { headers, responseType: 'json' })
      .subscribe(data => {
        console.log(data);
        // this._router.navigate(['/login', registerData.phone]);
        // this.preLogin({ phone: registerData.username, pin: registerData.password});
        // this.obtainAccessToken({username: registerData.phone, password: registerData.code});
      },
        err => {
          console.log(err);
          this.spinnerService.hide()
          if (err.status == 200) {
            //alert('Pin changed!');
            // this._router.navigate(['/prelogin', registerData.username]);
            //this.obtainAccessToken({ username: registerData.phone, password: registerData.code });
          } else {
            alert('Error paying');
          }

        });
    
  }

  execIntent(mintid, user_id) {
    let params = new URLSearchParams();
    console.log("execIntent");
    // mandargli lo user_id
    let headers = new HttpHeaders({ 'Content-type': 'application/json; charset=utf-8' });

    this._http.post(environment.apiServer + `/api/client/exec/intent/${mintid}`, `{"user_id":"${user_id}"}`, { headers, responseType: 'json', observe: 'response' })
      .subscribe(data => {
        console.log(data);
        // alert(data.status);
        // check for status if is 206 (partial content) mean that the identity check doesnt exuists so must be performed
        // if 201 was a payment and the transaction is ready to be confirmed
        // if 200 was a age check and we can get the redirect url form
        /// got redirect url from intent if age check otherwise ask confirmation or cancel transaction
        /// location.href = data
        // if intent was for age check
        // ask confirmation before because here happen the fee charge to merchant
        // ????? update intent using endpoint for this .. (which?)
        // if intent is for payment 

        // if 201 was a payment and the transaction is ready to be confirmed
        if (data.status == 201) {
          let text = `Confirm payment!\nAmount: ${data.body['amount']} ${data.body['currency']}\nto: `;
          if (confirm(text) == true) {
            this.confirm(mintid)
            alert("Payment Confirmed!");
          } else {
            this.cancel(mintid)
            alert("Payment Cancelled");
          }
        }

        if (data.status == 200) {
          //TODO: how to charge or not the merchant ?????
          // location.href = data.body["redirect_uri"];

          let text = `Confirm : `;
          if (confirm(text) == true) {
            this.confirmIntent(mintid, user_id)
            alert("Age check Confirmed!");
          } else {
            // this.cancel(data.body['id'])
            alert("Age check Cancelled");
          }
          this._router.navigate(['/']);
        }

        if (data.status == 206) {
          //TODO: how to charge or not the merchant ?????
          this.getTransactionId();
          this._router.navigate([data.body["redirect_uri"]]);
        }

        this.spinnerService.hide();

      },
        err => {
          console.log(err);
          this.spinnerService.hide()
          if (err.status == 200) {
            alert("success");
            this._router.navigate(['/']);
          } else {
            alert('Error executing intent: \n' + JSON.stringify(err.error));
            this._router.navigate(['/']);
          }

        });
    /*
    console.log(params.toString());
     this._http.post('http://localhost:8091/public/app/signUp', params.toString(), options)
    .map(res => res.json())
    .subscribe(
      data => { 
        console.log(data);
        // this.saveToken(data) 
      },
      err => {alert('Invalid SignUp'); this.spinnerService.hide()});
    ); 
    */
  }

  confirmIntent(mintid, user_id) {
    let params = new URLSearchParams();
    console.log("confirmIntent");
    // mandargli lo user_id
    let headers = new HttpHeaders({ 'Content-type': 'application/json; charset=utf-8' });

    this._http.post(environment.apiServer + `/api/client/confirm/intent/${mintid}`, null, { headers, responseType: 'text', observe: 'response' })
      .subscribe(data => {
        console.log(data);
        this.spinnerService.hide();
      },
        err => {
          console.log(err);
          this.spinnerService.hide()
          if (err.status == 202) { //accepted
            alert("Accepted");
            this._router.navigate(['/']);
          } else {
            alert('Error confirming intent: \n' + JSON.stringify(err.error));
            this._router.navigate(['/']);
          }

        });
    /*
    console.log(params.toString());
     this._http.post('http://localhost:8091/public/app/signUp', params.toString(), options)
    .map(res => res.json())
    .subscribe(
      data => { 
        console.log(data);
        // this.saveToken(data) 
      },
      err => {alert('Invalid SignUp'); this.spinnerService.hide()});
    ); 
    */
  }
  getJwtToken() {
    return Cookie.get('access_token');
  }

  saveToken(token) {
    var expireDate = new Date().getTime() + (1000 * token.expires_in);
    Cookie.set("access_token", token.access_token, expireDate);
    Cookie.set("refresh_access_token", token.refresh_token, expireDate);
    console.log('Obtained Access token: ' + token.access_token);
    this._router.navigateByUrl('/consent');
    // this._router.navigate(['/']);
  }

  getResource(resourceUrl): Observable<Foo> {
    console.log("resourceUrl: " + resourceUrl);
    let headers = new HttpHeaders({ 'Content-type': 'application/json; charset=utf-8' });
    return this._http.get<Foo>(environment.apiServer + resourceUrl, { headers, responseType: 'json' })
      // .map((res:Response) => res.json())
      .pipe(retry(1), catchError(this.handleError));
  }

  getTransactionId(): Observable<string> {
    console.log("getTransactionId");
    this.spinnerService.show();
    let headers = new HttpHeaders({ 'Content-type': 'application/json; charset=utf-8' });
    // this.spinnerService.hide();
    return this._http.get<string>(environment.apiServer + "/api/idcheck/init", { headers, responseType: 'json' })
      // .map((res:Response) => res.json())
      .pipe(retry(1), catchError(this.handleError));

  }

  getNfcTransactionId(): Observable<string> {
    Cookie.get('consensus');
    let consensus = Cookie.get('consensus') ? Cookie.get('consensus') : 'false';
    console.log("getTransactionId");
    this.spinnerService.show();
    let headers = new HttpHeaders({ 'Content-type': 'application/json; charset=utf-8' });
    // this.spinnerService.hide();
    return this._http.get<string>(environment.apiServer + `/api/idcheck/initnfc?nfc_consensus=${consensus}`, { headers, responseType: 'json' })
      // .map((res:Response) => res.json())
      .pipe(retry(1), catchError(this.handleError));

  }

  getMyWallets(): Observable<string> {
    console.log("getMyWallets");
    this.spinnerService.show();
    const user = JSON.parse(localStorage.getItem('currentUser'));

    let headers = new HttpHeaders({ 'Content-type': 'application/json; charset=utf-8' });
    // this.spinnerService.hide();
    return this._http.get<string>(environment.apiServer + `/api/user/wallets/${_.get(user, 'bank_user_id')}`, { headers, responseType: 'json' })
      // .map((res:Response) => res.json())
      .pipe(retry(1), catchError(this.handleError));

  }

  /*
  this.http.post('http://localhost:8090/registro', formData, { 
    observe: 'response', responseType: 'text' })
    .subscribe({ next: (response) => console.log('Response:', response.body),
     error: (error) => console.log('Error:', error.error), });


  async pay(source_wallet_id, destination_wallet_id, amount) {

    this.spinnerService.show();

    const payload =
    {
      "receiver_account": destination_wallet_id,
      "amount": amount,
      "currency": "eur",
      "details": "Payment",
      "payment_type": "internal"
    }


    let headers = new HttpHeaders({ 'Content-type': 'application/json; charset=utf-8' });

    this._http.post(environment.apiServer + `/api/wallets/transaction/${source_wallet_id}`, JSON.stringify(payload), { headers, responseType: 'json', observe: 'response' })
      // .map(res => res.json())
      .subscribe(
        data => {

          console.log(data);
          let text = `Confirm payment!\nAmount: ${data.body['amount']} ${data.body['currency']}\nto: `;
          if (confirm(text) == true) {
            this.confirm(data.body['id'])
            alert("Payment Confirmed!");
          } else {
            this.cancel(data.body['id'])
            alert("Payment Cancelled");
          }
          this.spinnerService.hide();
        },
        err => {
          console.log(err);
          alert('Error Sending Payment');
          this.spinnerService.hide();
        });

  }

  */

  enablePayments(questionaire) {
    console.log("enablePayments");
    /// TODO: CHECK IF IS IDENTIFICATION COMPLETE STATUS
    const user = JSON.parse(localStorage.getItem('currentUser'));

    if (_.get(user, 'bank_user_id') ? true : false) {
      this.sendQuestionaryData(_.get(user, 'bank_user_id'), questionaire)
    } else {
      let currentData;
      let headers = new HttpHeaders({ 'Content-type': 'application/json; charset=utf-8' });

      this._http.post(environment.apiServer + '/api/user/enable_payments', JSON.stringify({ "email": "foo@bar.com" }), { headers, responseType: 'json', observe: 'response' })
        // .map(res => res.json())
        .subscribe(
          data => {
            this.spinnerService.hide();
            console.log("posted enable_payments: " + data.body['id']);
            this.sendIdentityData(data.body['id'], questionaire);


            localStorage.setItem('currentUser', JSON.stringify(data));
            /*
            
            if (data.status == 200) {
              this._router.navigate(['/login', loginData.phone]);
            } else {
              alert("INVALID OR NOT EXISTING PIN");
              this._router.navigate(['/prelogin', loginData.phone]);
            }
            */
          },
          err => {
            console.log(err);
            if (err.status == 400) { // user already exist
              // this.sendIdentityData(data.body['id'], questionaire);
              this.sendIdentityData(err.error.reason.additional_data.id, questionaire);
            } else {
              alert('Error Enabling Payment: ' + JSON.stringify(err));
            }

            this.spinnerService.hide();
          });
    }
  }

  sendIdentityData(kern_user_id, questionaire) {
    console.log("sendIdentityData");
    /// TODO: CHECK IF IS IDENTIFICATION COMPLETE STATUS
    let headers = new HttpHeaders({ 'Content-type': 'application/json; charset=utf-8' });

    this._http.post(environment.apiServer + `/api/user/identity/${kern_user_id}`, null, { headers, responseType: 'json', observe: 'response' })
      // .map(res => res.json())
      .subscribe(
        data => {
          this.spinnerService.hide();

          console.log("Posted identity data" + data);
          // const user = JSON.parse(localStorage.getItem('currentUser'));
          this.sendQuestionaryData(kern_user_id, questionaire)
          // this._router.navigate(['/wallet']);
          /*
          
          if (data.status == 200) {
            this._router.navigate(['/login', loginData.phone]);
          } else {
            alert("INVALID OR NOT EXISTING PIN");
            this._router.navigate(['/prelogin', loginData.phone]);
          }
          */
        },
        err => {
          console.log(err);
          alert('Error sendIdentityData');
          this.spinnerService.hide();
        });
    /*
       let headers = new HttpHeaders({'Content-type': 'application/json; charset=utf-8'});
   
        this._http.post(environment.authServer +'/api/user/enable_payments',JSON.stringify(data),{ headers, responseType: 'json' })
        .subscribe(data => {
          console.log(data);
          this.spinnerService.hide();
          // this._router.navigate([`/prelogin/${registerData.username}/${registerData.password}`]);
          // this._router.navigate(['/login', registerData.username]);
          // this.preLogin({ phone: registerData.username, pin: registerData.password});
          // this.obtainAccessToken(registerData);
        },
        err => {
          console.log(err);
          this.spinnerService.hide()
          if (err.status == 409) {
            alert('User exists'); 
            // this._router.navigate(['/prelogin', registerData.username]);
          } else {
            alert('Invalid SignUp'); 
          }
          */
  }

  sendQuestionaryData(kern_user_id, data) {
    console.log("sendQuestionaryData");
    this.spinnerService.show();
    /// TODO: CHECK IF IS IDENTIFICATION COMPLETE STATUS
    let headers = new HttpHeaders({ 'Content-type': 'application/json; charset=utf-8' });

    this._http.post(environment.apiServer + `/api/user/questionnaire/${kern_user_id}`, JSON.stringify(data), { headers, responseType: 'json', observe: 'response' })
      // .map(res => res.json())
      .subscribe(
        data => {
          this.spinnerService.hide();
          console.log("sendQuestionaryData: " + data);
          this._router.navigate(['/wallet']);
          /*
          
          if (data.status == 200) {
            this._router.navigate(['/login', loginData.phone]);
          } else {
            alert("INVALID OR NOT EXISTING PIN");
            this._router.navigate(['/prelogin', loginData.phone]);
          }
          */
        },
        err => {
          console.log(err);
          alert('Error questionnaire');
          this.spinnerService.hide();
        });
    /*
       let headers = new HttpHeaders({'Content-type': 'application/json; charset=utf-8'});
   
        this._http.post(environment.authServer +'/api/user/enable_payments',JSON.stringify(data),{ headers, responseType: 'json' })
        .subscribe(data => {
          console.log(data);
          this.spinnerService.hide();
          // this._router.navigate([`/prelogin/${registerData.username}/${registerData.password}`]);
          // this._router.navigate(['/login', registerData.username]);
          // this.preLogin({ phone: registerData.username, pin: registerData.password});
          // this.obtainAccessToken(registerData);
        },
        err => {
          console.log(err);
          this.spinnerService.hide()
          if (err.status == 409) {
            alert('User exists'); 
            // this._router.navigate(['/prelogin', registerData.username]);
          } else {
            alert('Invalid SignUp'); 
          }
          */
  }
  refreshToken() {

    Cookie.delete("access_token"); // avoid to add BArear auth token
    // Cookie.delete("refresh_access_token");

    let headers = new HttpHeaders({ 'Content-type': 'application/x-www-form-urlencoded; charset=utf-8', 'Authorization': 'Basic ' + btoa("oauth_client_id:secret") });

    let params = new URLSearchParams();
    params.append('grant_type', 'refresh_token');
    params.append('refresh_token', Cookie.get('refresh_access_token'));

    // ?grant_type=refresh_token&refresh_token=[yourRefreshToken]"
    return this._http
      .post(`${environment.authServer}/auth/api/oauth/token`, params.toString(), { headers, responseType: 'json' })
      .pipe(
        tap((tokens) => {
          this.saveToken(tokens);
          const currentUrl = this._router.url;
          this._router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            this._router.navigate([currentUrl]);
          });
        }),
        catchError((error) => {
          console.log("Refresh token error: ", error)
          this.logout();
          return of(false);
        })
      )
  }


  checkCredentials() {
    if (!Cookie.check('access_token')) {
      this._router.navigate(['/prelogin']);
    }
  }

  logout() {

    let headers = new HttpHeaders({ 'Content-type': 'application/json; charset=utf-8' });

    this._http.post(`${environment.authServer}/auth/public/app/logout`, null, { headers, responseType: 'text', observe: 'response' })
      .subscribe(data => {
        console.log(data);
        Cookie.delete('access_token');
        Cookie.delete("refresh_access_token"); // avoid to add BArear auth token
        this._router.navigate(['/prelogin']);
        this.spinnerService.hide();
      },
        err => {
          console.log(err);
          this.spinnerService.hide()

            // alert('Error logout: \n' + JSON.stringify(err));
            this._router.navigate(['/']);

        });




  }

  // Error handling
  handleError(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(() => {
      return errorMessage;
    });
  }


}